/**
 * Builds the MSAL protectedResources map. GroupClasses API URLs carry an "/api/1.0/" suffix,
 * so the key is the API origin + '/*' (covers both the generated clients, which strip the
 * suffix, and the BaseHttpClient services, which keep it). Entries without a URL or scope are
 * skipped - requests to them go out without an Authorization header.
 */
export function buildProtectedResources(entries: [string | undefined, string | undefined][]): Record<string, string> {
    return entries.reduce((resources, [url, scope]) => {
        if (url && scope) {
            resources[new URL(url).origin + '/*'] = scope;
        }
        return resources;
    }, {} as Record<string, string>);
}
